<template>
    <div class="product-filters" v-for="(item, key) in filters" :key="key">
        <div class="product-filters--block">
            <div v-if="item['title']" class="product-filters--block--title">
                <h3><span>{{ item['title'] }}</span></h3>
            </div>

            <div class="product-filters--block--body">
                <label :for="`checkbox-${ i }${ key }`" class="label label-checkbox" v-for="(child, i) in item.body" :key="i">
                    <input type="checkbox" class="checkbox" :name="`checkbox-${ i }${ key }`" :id="`checkbox-${ i }${ key }`" :checked="filterData[ item.filter ].some(obj => obj.id === child.id)" @change="updateFilter( item, child )">
                    <h5>{{ child.title }}</h5>
                </label>
            </div>
        </div>
    </div>
</template>

<script>    
    export default {
        emits: ['filter'],
        props: {
            onFilter: {
                type: Function
            },
            filterData: {
                type: Object
            },
            author_id: {
                type: Number
            },
            category_id: {
                type: Number
            }
        },
        data() {
            return {
                filters: [],
                options: {
                    author_id: this.author_id,
                    category_id: this.category_id
                }
            }
        },
        created() {
            this.loadFilters()
        },
        methods: {
            loadFilters() {
                axios.post('/api/shop/filters', this.options )
                .then( response => { this.filters = response.data.filters })
                .catch( errors => {})
            },
            updateFilter( item, child ) {
                child.filter = item.filter
                this.$emit('filter', child)
            }
        },
    }
</script>